export default class ModalNames {
    static ERROR = 'ERROR';
    static CONFIRM = 'CONFIRM';
    static EXPORT_PROGRESS = 'EXPORT_PROGRESS';

    static REQUEST_PAUSE = 'REQUEST_PAUSE';
    static REQUEST_CHANGE_SERVICE = 'REQUEST_CHANGE_SERVICE';
    static REQUEST_CHANGE_EXECUTOR = 'REQUEST_CHANGE_EXECUTOR';
    static REQUEST_CHANGE_PRIORITY = 'REQUEST_CHANGE_PRIORITY';
    static REQUEST_SEND_TO_BITRIX24 = 'REQUEST_SEND_TO_BITRIX24';
    static REQUEST_SOLUTION = 'REQUEST_SOLUTION';
    static REQUEST_ACCEPT_WORK = 'REQUEST_ACCEPT_WORK';
    static REQUEST_CREATE = 'REQUEST_CREATE';
    static GLOBAL_SEARCH = 'GLOBAL_SEARCH';

    static ADMIN_PANEL_USER_CARD = 'ADMIN_PANEL_USER_CARD';
    static ADMIN_PANEL_CITY_CARD = 'ADMIN_PANEL_CITY_CARD';
    static ADMIN_PANEL_SERVICE_CARD = 'ADMIN_PANEL_SERVICE_CARD';
    static ADMIN_PANEL_SERVICE_FORM_FIELDS_CARD = 'ADMIN_PANEL_SERVICE_FORM_FIELDS_CARD';
    static ADMIN_PANEL_CATEGORY_CARD = 'ADMIN_PANEL_CATEGORY_CARD';
    static ADMIN_PANEL_SECURITY_GROUP_CARD = 'ADMIN_PANEL_SECURITY_GROUP_CARD';
    static ADMIN_PANEL_DICTIONARY_CARD = 'ADMIN_PANEL_DICTIONARY_CARD';

    static INVENTORY_TEMPLATE_PICKER = 'INVENTORY_TEMPLATE_PICKER';
    static INVENTORY_BATCH_CREATE = 'INVENTORY_BATCH_CREATE';
    static INVENTORY_PRESET_CARD = 'INVENTORY_PRESET_CARD';
    static INVENTORY_ATTRIBUTE_CARD = 'INVENTORY_ATTRIBUTE_CARD';
    static INVENTORY_ATTRIBUTE_CREATE_CARD = 'INVENTORY_ATTRIBUTE_CREATE_CARD';
    static INVENTORY_HOLDER_CARD = 'INVENTORY_HOLDER_CARD';

    // Бизнес-операции над оборудованием (7-F2A). Отдельные окна, а не одно универсальное:
    // «Выдать» и «Сменить владельца» делят форму, потому что она у них буквально одна,
    // а возврат и перемещение спрашивают совсем другое.
    static INVENTORY_ITEM_HOLDER_ACTION = 'INVENTORY_ITEM_HOLDER_ACTION';
    static INVENTORY_ITEM_RETURN = 'INVENTORY_ITEM_RETURN';
    static INVENTORY_ITEM_MOVE = 'INVENTORY_ITEM_MOVE';

    // Ремонт и списание (7-F2B). У каждого своя форма: у ремонта обязательно описание
    // неисправности, у возврата из ремонта выбирать нечего, у списания — обязательная
    // причина и красная кнопка.
    static INVENTORY_ITEM_REPAIR = 'INVENTORY_ITEM_REPAIR';
    static INVENTORY_ITEM_REPAIR_RETURN = 'INVENTORY_ITEM_REPAIR_RETURN';
    static INVENTORY_ITEM_WRITE_OFF = 'INVENTORY_ITEM_WRITE_OFF';

    // Неисправность (7-F2C). Отметка спрашивает обязательное описание, снятие —
    // необязательный комментарий и называет, куда вещь вернётся.
    static INVENTORY_ITEM_MARK_BROKEN = 'INVENTORY_ITEM_MARK_BROKEN';
    static INVENTORY_ITEM_CLEAR_FAULT = 'INVENTORY_ITEM_CLEAR_FAULT';
}
